<template>
  <div class="m-12 mt-2 flex flex-col w-auto">
    <div class="w-full flex flex-row justify-between p-4 px-0">
      <breadcrumbs :links="links"></breadcrumbs>
    </div>

    <element-form
      v-on:add-element="updateElement"
      :repos="repos"
      :element="element"
      mode='update'
    ></element-form>

  </div>
</template>

<script>
// import Component from "../component_location"
import ElementForm from "@/views/Narratives/ElementForm.vue";
import Breadcrumbs from "@/components/Breadcrumbs.vue";
import { reportError, stripHash } from "@/utils.js";

export default {
  components: { ElementForm, Breadcrumbs },

  props: ["username", "narrativeName", "elementId"],

  data() {
    return {};
  },

  watch: {},

  methods: {
    updateElement() {
      stripHash(this.element)
      this.$samsa
        .updateElement(this.element)
        .then((res) => {
          this.$router.push({
            name: "Narrative",
            params: {
              username: this.username,
              narrativeName: this.narrativeName,
            },
          });
        })
        .catch((err) => {
          reportError(err);
        });
    },
  },

  computed: {
    element() {
      return this.$store.state.element;
    },

    repos() {
      return this.$store.state.repos;
    },

    links() {
      return [
        {
          name: this.$store.getters['users/nickname'] + "'s narratives",
          route: {
            name: "Narratives",
            params: { username: this.username },
          },
        },
        {
          name: this.narrativeName,
          route: {
            name: "Narrative",
            params: {
              username: this.username,
              narrativeName: this.narrativeName,
            },
          },
        },
        {
          name: "update element",
          route: {
            name: "NewElement",
            params: {
              username: this.username,
              narrativeName: this.narrativeName,
            },
          },
        },
      ];
    },
  },

  mounted() {
    // LOAD THE NARRATIVE
    this.$samsa
      .getElement(this.elementId)
      .then((res) => {
        this.$store.commit("setElement", res.data);
      })
      .catch((err) => {
        reportError(err);
      });

    // NOW GET REPOS
    this.$samsa
      .getRepos(this.username)
      .then((res) => {
        this.$store.commit("setRepos", res.data);
      })
      .catch((err) => {
        reportError(err);
      });
  },
};
</script>

<style></style>
